module.exports = __webpack_public_path__ + "img/D_Read_more_risks.26eb9e50.svg";